"use client";

import React, { PropsWithChildren, useState, useTransition } from "react";

import { FilterablePaginatedSectionContextProvider } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import { filterablePaginatedSectionWrapper } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";
import { useFilterablePaginatedScroll } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/useFilterablePaginatedScroll";

export const FilterablePaginatedSectionWrapper: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { scrollRef, scrollToTop } = useFilterablePaginatedScroll();
  const [isScrollingToTop, setIsScrollingToTop] = useState(false);
  const [isTransitioning, startTransition] = useTransition();

  return (
    <FilterablePaginatedSectionContextProvider
      value={{
        scrollRef,
        scrollToTopFunc: scrollToTop,
        isScrollingToTop,
        setIsScrollingToTop,
        isTransitioning,
        startTransition,
      }}
    >
      <div className={filterablePaginatedSectionWrapper} ref={scrollRef}>
        {children}
      </div>
    </FilterablePaginatedSectionContextProvider>
  );
};
